import { 
  Calendar, 
  Users, 
  Search, 
  Building2, 
  Phone, 
  Briefcase,
  LucideIcon 
} from "lucide-react";

export const getEventColor = (type?: string): string => {
  switch (type) {
    case 'interview':
      return 'bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300 hover:bg-blue-200 dark:hover:bg-blue-900/60';
    case 'screening':
      return 'bg-green-100 dark:bg-green-900/50 text-green-700 dark:text-green-300 hover:bg-green-200 dark:hover:bg-green-900/60';
    case 'research':
      return 'bg-purple-100 dark:bg-purple-900/50 text-purple-700 dark:text-purple-300 hover:bg-purple-200 dark:hover:bg-purple-900/60';
    case 'client':
      return 'bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-300 hover:bg-amber-200 dark:hover:bg-amber-900/60';
    case 'prospecting':
      return 'bg-rose-100 dark:bg-rose-900/50 text-rose-700 dark:text-rose-300 hover:bg-rose-200 dark:hover:bg-rose-900/60';
    default:
      return 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-900/60';
  }
};

export const getEventIcon = (type?: string): LucideIcon => {
  switch (type) {
    case 'interview':
      return Users;
    case 'screening':
      return Phone;
    case 'research':
      return Search;
    case 'client':
      return Building2;
    case 'prospecting':
      return Briefcase;
    default:
      return Calendar;
  }
};
